export const faqLinks = [
  {
    q: '六点场是什么时候？',
    a: '每天 18:00 集中更新一次，全天素材都会并入这一场，遇到重大反转会追加加更标记。',
  },
  {
    q: '「待核实」和「已确认」差在哪？',
    a: '待核实指只有单一来源或缺少可核对细节；出现时间点、出处或当事方回应后才会升级。',
  },
  {
    q: '反转会不会覆盖原来的说法？',
    a: '不会。初版说法与最新进展会同时保留在时间线上，方便前后对照。',
  },
];